import React from 'react'
import styled, { css } from 'styled-components'

import { cssBreakpoints, tableHeaderCellStyles, tableStylesConfig } from '../../../_constants/styles'
import ToolTip from '../../Tooltip/Tooltip'
import { FaRegQuestionCircle } from 'react-icons/fa'

export const S_HeaderCell = styled.div`
  ${tableHeaderCellStyles}

  ${(props) =>
    props.mobileMaxWidth &&
    css`
      @media screen and (max-width: ${cssBreakpoints.mobileMd}) {
        max-width: ${(props) => (props.mobileMaxWidth ? `${props.mobileMaxWidth}px` : 'none')};
        width: 100%;
      }
    `}
    
    @media (max-width: ${cssBreakpoints.mobileLg}) {
    white-space: unset;
    font-size: ${tableStylesConfig.mobileFontSize};
    padding: ${tableStylesConfig.cellPaddingVMobile} ${tableStylesConfig.cellPaddingHMobile};
  }
`

const S_HeaderCell_Inner = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;

  .tooltip-question {
    margin-left: 2px;
    line-height: 1em;
    align-self: flex-end;
  }
`
const HeaderCellContent = (props) => {
  const { headingType, headingTooltip, label } = props
  switch (headingType) {
    case 'tooltip':
      return (
        <>
          <span>{label}</span>
          <ToolTip content={headingTooltip}>
            <span className={`tooltip-question`}>
              <FaRegQuestionCircle />
            </span>
          </ToolTip>
        </>
      )
    default:
      return label
  }
}

export const HeaderCell = (props) => {
  const { style, mobileMaxWidth = null } = props
  return (
    <S_HeaderCell mobileMaxWidth={mobileMaxWidth} style={style || {}}>
      <S_HeaderCell_Inner>
        <HeaderCellContent {...props} />
      </S_HeaderCell_Inner>
    </S_HeaderCell>
  )
}
